import { BrowserView, MobileView } from 'react-device-detect'

import { Tick02Icon } from '@hugeicons/react'

import { ScrollMenu } from '@/shared/ui/ScrollMenu'

export const AvatarEditorStyleSelector = ({
  styles,
  selectedOption,
  selectedStyle,
  selectedColor,
  className = '',
  onSelectStyle
}) => {
  const SelectedOptionComponent =
    selectedOption?.component || (() => <>Não implementado</>)

  return (
    <div id="avatar-editor-style-selector">
      <BrowserView>
        <div className={`flex flex-wrap gap-2 lg:gap-4 ${className}`}>
          {styles.map((style, index) => {
            const isSelected = selectedStyle === style

            return (
              <button
                key={`style-${index}`}
                type="button"
                className={`relative w-[75px] h-[75px] lg:w-[125px] lg:h-[125px] rounded-lg border-[3px] cursor-pointer animate__animated animate__fadeInRight animate__faster ${
                  isSelected ? 'border-success bg-success/10' : 'bg-white border-gray-200'
                }`}
                onClick={() =>
                  !isSelected && onSelectStyle(selectedOption.slug, style)
                }
              >
                <div className="overflow-hidden relative w-full h-full">
                  <SelectedOptionComponent
                    name={selectedOption.slug}
                    style={style}
                    color={selectedColor}
                    withSvg
                  />
                </div>

                {isSelected && (
                  <span className="absolute w-[15px] h-[15px] flex items-center justify-center rounded-full bg-success top-0 right-0 m-2">
                    <Tick02Icon variant="solid" size={12} className="text-white" />
                  </span>
                )}
              </button>
            )
          })}
        </div>
      </BrowserView>
      <MobileView>
        <ScrollMenu className="flex gap-2 lg:gap-3 py-6">
          {styles.map((style, index) => {
            const isSelected = selectedStyle === style

            return (
              <button
                key={`style-${index}`}
                type="button"
                className={`relative w-[75px] h-[75px] lg:w-[100px] lg:h-[100px] rounded-lg border-[3px] cursor-pointer animate__animated animate__fadeInRight animate__faster ${
                  isSelected ? 'border-success bg-success/10' : 'bg-white border-gray-200'
                }`}
                onClick={() =>
                  !isSelected && onSelectStyle(selectedOption.slug, style)
                }
              >
                <div className="overflow-hidden relative w-full h-full">
                  <SelectedOptionComponent
                    name={selectedOption.slug}
                    style={style}
                    color={selectedColor}
                    withSvg
                  />
                </div>

                {isSelected && (
                  <span className="absolute w-[15px] h-[15px] flex items-center justify-center rounded-full bg-success top-0 right-0 m-2">
                    <Tick02Icon variant="solid" size={12} className="text-white" />
                  </span>
                )}
              </button>
            )
          })}
        </ScrollMenu>
      </MobileView>
    </div>
  )
}
